import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Cookies from "js-cookie";
import "./shared.css";
import { zoneWidgets } from "../api";
import { setZoneWidgets, setSelectedZone } from "../redux";
import { ModalComp, Add, CameraComp } from "./";
import { withRouter } from "react-router-dom";
import { useTranslation } from "react-i18next";
const ShortcutCompp = (props) => {
  const { t } = useTranslation();
  const { modal } = props;
  const token = Cookies.get("token");
  const dispatch = useDispatch();
  const dashboardDetail = useSelector((state) => state.dashboardDetails);
  const dashboardZones = useSelector(
    (state) => state.dashboardZones.dashboardZones
  );
  const [showRoom, setShowRoom] = useState(false);
  const [zoneName, setZoneName] = useState("");
  const [openAddModal, setOpenAddModal] = useState(false);
  const toggleAdd = () => setOpenAddModal(!openAddModal);
  const [openCameraModal, setOpenCameraModal] = useState(false);
  const toggleCamera = () => setOpenCameraModal(!openCameraModal);

  const zoneClick = (zone) => {
    setZoneName(zone.zone_caption);
    dispatch(setSelectedZone(zone));
    const data = new FormData();
    data.append("zone", zone.id);
    zoneWidgets(data, token)
      .then((res) => {
        dispatch(setZoneWidgets(res.data.data));
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
        } else {
          dispatch(setZoneWidgets([]));
        }
      });
  };

  return (
    <>
      <ModalComp modal={openAddModal} toggle={toggleAdd} component={<Add />} />
      <ModalComp
        modal={openCameraModal}
        toggle={toggleCamera}
        component={<CameraComp />}
      />
      <div
        className={`p-3 align-items-center justify-content-around shortcut ${modal}`}
      >
        <i className="circleIcon d-block text-center icon-device"></i>
        <i
          className="circleIcon d-block text-center icon-video cursor"
          onClick={toggleCamera}
        ></i>
        <div
          className="selectBox text-white d-flex align-items-center justify-content-around px-2 cursor"
          onClick={() => setShowRoom(!showRoom)}
        >
          <i className="icon-house"></i>
          <p className="m-0 fn12">
            {zoneName
              ? zoneName
              : dashboardZones && dashboardZones[0]["zone_caption"]}
          </p>
          <i className="icon-down-open-big"></i>
        </div>
      </div>
      {showRoom && (
        <div
          className="w-100 h-100 position-fixed roomSelect"
          onClick={() => setShowRoom(false)}
        >
          <div className="roomSelectCard position-absolute m-auto text-center flex-column d-flex align-items-center">
            <div className="homeInfo d-flex align-items-center px-2">
              <span className="d-block ml-2 homeInfoIcon rounded-circle d-flex align-items-center justify-content-center">
                <i className="icon-house"></i>
              </span>
              <div>
                <p className="fn">{dashboardDetail.dashboard_caption}</p>
                <p className="muted m-0 fn12 text-right">
                  {dashboardDetail.zone_allowed_count === 1
                    ? `${dashboardDetail.zone_allowed_count} ${t("اتاق")}`
                    : `${dashboardDetail.zone_allowed_count} ${t("اتاق ها")}`}
                </p>
              </div>
            </div>
            {dashboardZones?.map((zone, index) => {
              return (
                <div
                  key={index}
                  className="px-5 py-6 rooms cursor my-2"
                  onClick={() => zoneClick(zone)}
                >
                  <p className="fn m-0">{zone.zone_caption}</p>
                </div>
              );
            })}
            <div className="addRoom py-6 px-5 my-2 cursor" onClick={toggleAdd}>
              <p className="text-white m-0 fn"> {t("اتاق جدید")} +</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const Shortcut = withRouter(ShortcutCompp);

export { Shortcut };
